export const auditPages = {
  list: () => import('./pages/AuditPage'),
};
